/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseTextHeaderBlock } from './DatabaseTextHeaderBlock';
import {
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';

/**
 * 
 * @export
 * @interface DatabaseFinePrintHeaderBlock
 */
export interface DatabaseFinePrintHeaderBlock extends DatabaseTextHeaderBlock {
}

/**
 * Check if a given object implements the DatabaseFinePrintHeaderBlock interface.
 */
export function instanceOfDatabaseFinePrintHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFinePrintHeaderBlockFromJSON(json: any): DatabaseFinePrintHeaderBlock {
    return DatabaseFinePrintHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseFinePrintHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFinePrintHeaderBlock {
    return json;
}

export function DatabaseFinePrintHeaderBlockToJSON(value?: DatabaseFinePrintHeaderBlock | null): any {
    return value;
}

